exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "small[data-v-122b3492]{font-size:.5em}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/dashboard/Sessions.vue"],"names":[],"mappings":"AACA,uBAAyB,cAAgB,CACxC","file":"Sessions.vue","sourcesContent":["\nsmall[data-v-122b3492] { font-size: .5em;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-122b3492","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/Sessions.vue
// module id = 839
// module chunks = 0 1 2